import { configContentHub } from "@pub/config";

export const getResolvedContentHubLayout = (variantName?: string) => {
  const defaultConfig = configContentHub.layout?.stories;
  const variantConfig = configContentHub.layout?.variant?.find(
    (variant) => variant.name === variantName,
  );

  return {
    elements: variantConfig?.elements ?? defaultConfig?.elements,
    CustomPrimaryBody: variantConfig?.CustomPrimaryBody,
    ListingLayoutComponent: variantConfig?.ListingLayoutComponent,
  };
};
